function nmInitReveals(){
  var els = document.querySelectorAll('.nm-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)){
    els.forEach(function(el){ el.classList.add('nm-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting){
        entry.target.classList.add('nm-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function(el){ obs.observe(el); });
}

function nmInitCountUp(){
  var els = document.querySelectorAll('[data-nm-count]');
  if (!els.length) return;
  var done = new WeakSet();
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (!entry.isIntersecting || done.has(entry.target)) return;
      done.add(entry.target);
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-nm-count')) || 0;
      var suffix = el.getAttribute('data-nm-suffix') || '';
      var dur = 1400;
      var start = null;
      function step(ts){
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function(el){ obs.observe(el); });
}

function nmAgregarKitAlCarrito(items, codigoDescuento, callback){
  var cartDrawer = document.querySelector('cart-drawer');

  function agregar(){
    var body = { items: items };
    if (cartDrawer){
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r){ return r.json(); });
  }

  var trabajo = codigoDescuento
    ? fetch('/discount/' + encodeURIComponent(codigoDescuento) + '?redirect=%2Fcart', { credentials: 'same-origin' }).catch(function(){}).then(agregar)
    : agregar();

  trabajo.then(function(response){
    if (response && response.status){
      callback(new Error(response.description || response.message || 'No se pudo agregar el kit.'));
      return;
    }
    if (cartDrawer && response.sections){
      cartDrawer.renderContents({ id: response.id, sections: response.sections });
    }
    callback(null);
  }).catch(function(e){
    callback(e);
  });
}

function nmInitKitSelector(){
  var wraps = document.querySelectorAll('[data-nm-kits]');
  wraps.forEach(function(wrap){
    var opciones = wrap.querySelectorAll('[data-nm-kit-option]');
    var boton = wrap.querySelector('[data-nm-kit-cta]');
    if (!opciones.length) return;
    function activar(op){
      opciones.forEach(function(o){ o.classList.remove('nm-kit-activo'); });
      op.classList.add('nm-kit-activo');
      var texto = op.getAttribute('data-nm-kit-cta-texto');
      if (boton) boton.dataset.nmKitItems = op.getAttribute('data-nm-kit-items') || '[]';
      if (boton) boton.dataset.nmKitDiscount = op.getAttribute('data-nm-kit-discount') || '';
      if (boton && texto) boton.textContent = texto;
    }
    var porDefecto = wrap.querySelector('[data-nm-kit-defecto]') || opciones[0];
    activar(porDefecto);
    opciones.forEach(function(op){
      op.addEventListener('click', function(){
        activar(op);
      });
    });

    if (boton){
      boton.addEventListener('click', function(){
        if (boton.disabled) return;
        var items;
        try { items = JSON.parse(boton.dataset.nmKitItems || '[]'); } catch (e) { items = []; }
        if (!items.length) return;
        var textoOriginal = boton.textContent;
        boton.disabled = true;
        boton.textContent = '...';
        nmAgregarKitAlCarrito(items, boton.dataset.nmKitDiscount, function(error){
          boton.disabled = false;
          boton.textContent = textoOriginal;
          if (error){
            alert(error.message);
          }
        });
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', function(){
  nmInitReveals();
  nmInitCountUp();
  nmInitKitSelector();
});
